import { CREATE_VIDEO_TOUR, GET_ALL_VIDEO_TOURS, UPDATE_VIDEO_TOUR, DELETE_VIDEO_TOUR } from "./actionTypes";

const initialState = {};

const videoTours = (state = initialState, action) => {
	const { payload, type } = action;

	switch (type) {
		case CREATE_VIDEO_TOUR: {
			const { videoTourId, videoTourData } = payload;
			return {
				...state,
				[videoTourId]: { ...videoTourData, id: videoTourId }
			};
		}

		case UPDATE_VIDEO_TOUR: {
			const { videoTourId, updatedData } = payload;
			return {
				...state,
				[videoTourId]: {
					...state[videoTourId],
					...updatedData
				}
			};
		}

		case GET_ALL_VIDEO_TOURS: {
			// Assuming the payload is an array of video tours with `id` as a key
			return payload.reduce((acc, videoTour) => {
				acc[videoTour.id] = videoTour;
				return acc;
			}, {});
		}

		case DELETE_VIDEO_TOUR: {
			const { videoTourId } = payload;
			const newState = { ...state };
			delete newState[videoTourId]; // Remove the video tour by its ID
			return newState;
		}

		default:
			return state;
	}
};

export default videoTours;
